import React, { Component } from "react";

export default class UploadInfoSeries extends Component{
  constructor(props) {
    super(props);
    this.state = {
      files: this.props.files,
      processing: false,
      progress: 0,
      searchWord: ''
    };

    this.handleUploadInfoSeries = this.handleUploadInfoSeries.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSelectFile = this.handleSelectFile.bind(this);
    this.handleSearchBoxChange = this.handleSearchBoxChange.bind(this);
  }

  handleSearchBoxChange(e){
    const searchWord = e.target.value;
    this.setState({searchWord});
  }

  showFilteredFiles(){
    if(!this.state.searchWord||this.state.searchWord.length<2){
      return this.state.files;
    }else{
      return this.state.files.filter(f=>(f.name.toLowerCase().includes(this.state.searchWord.toLowerCase())));
    }
  }

  async handleUploadInfoSeries(e) {
    e.preventDefault();
    this.props.handleUploadInfoSeries(this.state.files.filter((file)=>(file.isChecked && file.isChecked === true)));
    this.props.handleCancel();
  }

  handleCancel(e) {
    e.preventDefault();
    this.props.handleCancel();
  }

  handleSelectFile(e){
    let files = this.state.files;
    files.forEach(file=>{
      if (file.path === e.target.id)file.isChecked =  e.target.checked
    })
    // console.log(files);
    this.setState({files: files})
  }

  render() {
    return (

      

      <tr className={this.props.hide ? 'infoSeries hide' : 'infoSeries show'} >
        <td colSpan="2">
          
          <div>
              <input type="text" onChange={this.handleSearchBoxChange} autoComplete="off"/>
              <span id="search-info-series-button-group" >
                <button name="uploadInfoSeries" onClick={this.handleUploadInfoSeries}>UPLOAD</button>
                <button className="btn" onClick={this.handleCancel}>Cancel</button>
              </span>
          </div>

          <div className="scrollable">          
            <table >
              <tbody  >        
                {this.showFilteredFiles().filter(f=>(f.type==='file')).map((file,idx)=>(
                  <tr key={file.path} className={idx % 2 === 0 ? 'odd' : 'even'} >
                    <td>
                        <input id={file.path} type="checkbox" onChange={this.handleSelectFile} checked={file.isChecked} /> {file.name}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>           
      
        </td>
      </tr>
      
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UploadInfoSeries.js